import type { NextPage } from "next";
import React from "react";
import { Head } from "@/components/Head";
import { GetServerSidePropsResult } from "next/types";
import { withErrorReportingAndAuthorization } from "../../middlewares/withErrorReportingAndAuthorisation";
import {
  ColumnsSection,
  ColumnsSectionLeft,
  ColumnsSectionRight,
  ColumnsSectionSeperator,
} from "@/components/Sections/ColumnsSection";
import Button from "@/components/Button";

type PageProps = unknown;

const getServerSidePropsImpl = async (): Promise<
  GetServerSidePropsResult<PageProps>
> => {
  return {
    props: {},
  };
};

export const getServerSideProps = withErrorReportingAndAuthorization(
  getServerSidePropsImpl
);

const MotivationScanOnboardPage: NextPage<PageProps> = () => {
  return (
    <>
      <Head title={"Motivation scan - Start here"} description={""} />
      <ColumnsSection color={"light-blue"}>
        <ColumnsSectionLeft className="!py-3xl tablet-lg:h-screen flex justify-center items-center">
          <h1 className={"text-style-headline2 text-light-yellow text-center"}>
            Start building your learning pathway
          </h1>
        </ColumnsSectionLeft>
        <ColumnsSectionSeperator />
        <ColumnsSectionRight className="tablet-lg:h-screen flex items-center">
          <div className="flex flex-col gap-y-lg justify-center text-style-body-1 text-white">
            <p>
              You will be presented with various topics. Choose the topics you
              feel most passionate about or those you would like to explore
              further.
            </p>
            <p>
              Based on your input and preferences, you will receive a
              compilation of the results along with suggestions of learning
              opportunities you might be interested in.
            </p>
            <p>The motivation scan will take approximately 10 minutes.</p>
            <div className="flex-grow-0">
              <Button
                className="w-full tablet-sm:w-auto"
                label="Let's get started"
                href="/motivation-scan"
              />
            </div>
          </div>
        </ColumnsSectionRight>
      </ColumnsSection>
    </>
  );
};

export default MotivationScanOnboardPage;
